export const ZAPIER_COMMANDE =
  'https://hooks.zapier.com/hooks/catch/951706/atzv8m/silent/'

export const ZAPIER_DEMANDE =
  'https://hooks.zapier.com/hooks/catch/951706/atk4il/silent/'



// WEBPACK FOOTER //
// ./src/constants.js